import { render, staticRenderFns } from "./eventSidebar.vue?vue&type=template&id=1fe61d9a&scoped=true&"
import script from "./eventSidebar.vue?vue&type=script&lang=js&"
export * from "./eventSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe61d9a",
  null
  
)

export default component.exports